let module = angular.module('api-config', []);

// Keep this around for lifetime of window/application, regardless of
// angular service lifecycle.
var globalState = {};

module.service('ApiConfig', function ($q, $http) {
  'ngInject';

  // Once loading is complete, broadcast when our
  // promises have resolved to allow routing
  let deferredResolve = $q.defer();
  this.verifyResolved = (res) => {
    return deferredResolve.promise;
  };

  // Stub
  this.account = {};
  this.stream = {};
  this.boxcaster = {};
  this.time_zones = [];
  this.content_languages = [];
  this.ticket = {};
  this.currentPage = 1;

  // Grab actual config values from API
  if (!_.keys(globalState).length) {
    $http.get(`${API_ROOT}/api_configuration`).then((result) => {
      _.each(result.data, (value, key) => {
        this[key] = angular.copy(value);
        globalState[key] = angular.copy(value);
      });
      deferredResolve.resolve();
    });
  } else {
    _.each(globalState, (value, key) => (this[key] = value));
    deferredResolve.resolve();
  }

  this.scopes = () => $http.get(`${API_ROOT}/api_configuration/scopes`).then((r) => r.data);

  // Support basic promise API
  this.then = function (...args) {
    return deferredResolve.promise.then(...args);
  };

  // Function to return field limits as a flattened hash per model
  this.modelFieldLimits = (modelName, constraintName) => {
    const constraints = angular.copy(this.model_constraints[modelName] || {});
    _.each(constraints, (v, k) => {
      v = v[constraintName];
      if (!v) {
        delete constraints[k];
      } else {
        constraints[k] = v;
      }
    });
    return constraints;
  };
});

export default module;



// WEBPACK FOOTER //
// ./app/services/api-config.js